$('.js-items__inputs-area--textarea').on('input', function(){
  let maxlength = $(this).attr("maxlength");
  let currentLength = $(this).val().length;

  // Change current character length
  $('.js-items__inputs-area--span').find('#current').text(currentLength);
  
  // Change current character color when reach max limit
  if( currentLength >= maxlength ){
    $('.js-items__inputs-area--span').css({'color' : '#e95c49'});
  } else {
    $('.js-items__inputs-area--span').css({'color' : '#cdd0d8'});
  }
});


const handleSubmit = (event) => {
  event.preventDefault();

  const myForm = event.target;
  const formData = new FormData(myForm);
  
  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(formData).toString(),
  })
    .then(() => window.location.href = "email-confirmation.html")
    .catch((error) => alert(error));
};

document
  .querySelector("form")
  .addEventListener("submit", handleSubmit);
